var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccidents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.433 5C10.1294 5.00183 7.9078 5.85573 6.19604 7.3974C4.48429 8.93907 3.40341 11.0595 3.16138 13.3504H21.7165C21.4743 11.0574 20.3917 8.93545 18.6774 7.39351C16.9632 5.85156 14.7387 4.99891 12.433 5V5Z",
    fill: "#E4032E",
    stroke: "white",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.3504H3.10226L1 14.3188V15.2874H21.941C22.004 14.6433 22.004 13.9945 21.941 13.3504H22Z",
    fill: "#E4032E",
    stroke: "white",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9212 6.71255H5.81885V12.2284H6.43305C6.73433 11.0376 7.29206 9.92702 8.06731 8.97428C8.84255 8.02154 9.81651 7.24961 10.9212 6.71255V6.71255Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74814 6.71255H3.84656V12.4409H5.74814V6.71255Z",
    fill: "#E4032E",
    stroke: "white",
    strokeWidth: 0.34,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccidents);
export default __webpack_public_path__ + "static/media/accidents.9fa0ee9255cb33f01d4984d7d6563433.svg";
export { ForwardRef as ReactComponent };